var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCppLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c (1) 2",
    clipPath: "url(#clip0_0_9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.9313 12.5387H25.6967V13.8205H24.4618V12.5387H23.2274V11.2572H24.4618V9.97559H25.6967V11.2572H26.9313V12.5387ZM22.4263 12.5387H21.1919V13.8205H19.9573V12.5387H18.7227V11.2572H19.9573V9.97559H21.1919V11.2572H22.4263V12.5387Z",
    fill: "#F8FAFC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.252 14.642C15.3315 16.3365 13.5825 17.4816 11.5752 17.4816C9.58015 17.4816 7.84102 16.3508 6.91589 14.6743C6.45115 13.833 6.20709 12.88 6.20805 11.9102C6.20805 8.83326 8.61109 6.33887 11.5752 6.33887C13.5574 6.33887 15.2873 7.45556 16.217 9.11497L20.9082 6.31079C19.0436 2.96956 15.5624 0.72168 11.5752 0.72168C5.62237 0.72168 0.796875 5.73103 0.796875 11.9102C0.796875 13.9374 1.31639 15.8384 2.22437 17.4782C4.08427 20.8371 7.57535 23.0988 11.5752 23.0988C15.5823 23.0988 19.0789 20.828 20.9361 17.4592L16.252 14.642Z",
    fill: "#F8FAFC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCppLogo);
export default __webpack_public_path__ + "static/media/cppLogo.e2d87582546e77c7a62a63c48eca7368.svg";
export { ForwardRef as ReactComponent };